export const requiredFields =
    process.env.REACT_APP_COMMERCIAL_CRM_FIELDS_BASE_WHATSAPP?.split(',') || [
        'phone',
        'name',
    ];
